// extracted by mini-css-extract-plugin
module.exports = {"BrandList":"BrandList--3y1gI","header":"header--3925J","headerLeft":"headerLeft--2YI_A","headerRight":"headerRight--2IHmd","content":"content--3yJ6q"};